


























import { computed, defineComponent, ref } from '@vue/composition-api'
import { useApi } from '@/composable/useApi'
import { useI18n } from 'vue-i18n-bridge'
import { useToasts } from '@/composable/useToasts'
import { useValidator } from '@/composable/validator/useValidator'
import CustomerAddressInputs from '@/components/domains/customers/customer/CustomerAddressInputs.vue'
import type {
  Customer,
  CustomerAddress,
  CustomerAddressCreateRequest
} from '@futureecom/futureecom-js/dist/services/customer-service'
import type { PropType } from '@vue/composition-api'
import type { RuleDefinitions } from '@/types/validator'

export default defineComponent({
  name: 'CustomerAddressCreate',

  components: { CustomerAddressInputs },

  props: {
    value: {
      type: Object as PropType<Customer>,
      required: true
    }
  },

  emits: {
    created: (_val: CustomerAddressCreateRequest | CustomerAddress) => true
  },

  setup(props, { emit }) {
    const { t } = useI18n()
    const { addSuccessToast, addErrorToast } = useToasts()

    const getTemplate = (): CustomerAddressCreateRequest => ({
      given_name: '',
      family_name: '',
      address_line1: '',
      locality: '',
      administrative_area: '',
      country_code: '',
      locale: '',
      postal_code: '',
      is_default: false,
      organization: ''
    })

    const item = ref<CustomerAddressCreateRequest>(getTemplate())

    const isOpen = ref(false)

    const loading = ref(false)
    const { errors, validate, isValid, setErrorsFromAPI } = useValidator(item.value)

    const rules = computed((): RuleDefinitions => {
      return {
        given_name: ['required'],
        family_name: ['required'],
        country_code: ['required'],
        postal_code: ['required'],
        address_line1: ['required'],
        locality: ['required']
      }
    })

    const onItemChange = () => validate(item.value, rules.value)
    const onOpenChange = () => {
      item.value = getTemplate()
      setErrorsFromAPI({})
    }

    const createHandler = async (): Promise<void> => {
      validate(item.value, rules.value, true)

      if (!isValid.value) {
        return
      }

      try {
        if (props.value.id) {
          loading.value = true
          //@ts-expect-error
          item.value = await useApi().customers.createCustomerAddress(props.value.id, item.value)
        }
        addSuccessToast(t('Created address'))
        isOpen.value = false
        emit('created', item.value)
      } catch (err: any) {
        if (err.response?.data.message) {
          addErrorToast(err.response?.data.message)
        }
        setErrorsFromAPI(err.response?.data.errors || {})
      } finally {
        loading.value = false
      }
    }

    return {
      item,
      errors,
      isValid,
      loading,
      isOpen,
      createHandler,
      onItemChange,
      onOpenChange
    }
  }
})
